// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import psignEntity from './entities/psign.json';
import psignMenu from '../pages/psign/menu.json';
import psignFullForm from '../pages/psign/forms/full.json';
import psignContextForm from '../pages/psign/forms/context.json';
import psignMiniForm from '../pages/psign/forms/mini.json';
import psignLookupForm from '../pages/psign/forms/lookup.json';
import psignTableView from '../pages/psign/views/table.json';
import psignStagesView from '../pages/psign/views/stages.json';
import psignCardsView from '../pages/psign/views/cards.json';
import psignInlineView from '../pages/psign/views/inline.json';
import psignBacklogView from '../pages/psign/views/backlog.json';
import psignSplitView from '../pages/psign/views/split.json';
import psignCalendarView from '../pages/psign/views/calendar.json';
import psignDashboardView from '../pages/psign/views/dashboard.json';

/** Тип запису «Індикатор раннього попередження» зі сторінками пакета: меню, форми та подання з pages/psign/. */
export const psignDefinition: IRecordTypeDefinition = {
  ...psignEntity,
  views: assembleViewSet({
      table: psignTableView,
      stages: psignStagesView,
      cards: psignCardsView,
      inline: psignInlineView,
      backlog: psignBacklogView,
      split: psignSplitView,
      calendar: psignCalendarView,
      dashboard: psignDashboardView,
  }),
  form: psignFullForm,
  forms: { full: psignFullForm, context: psignContextForm, mini: psignMiniForm, lookup: psignLookupForm },
  menu: psignMenu,
} as IRecordTypeDefinition;
